import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password
      });

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
      toast.success('Login successful!');
      navigate('/dashboard/impact');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{background: '#F8F7F4'}}>
      <div className="max-w-md w-full">
        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 mb-8 transition-opacity hover:opacity-70"
          style={{color: '#6B6B6B', fontSize: '14px'}}
        >
          <ArrowLeft size={16} />
          <span>Back to Home</span>
        </button>

        {/* Logo */}
        <div className="text-center mb-10">
          <h1 className="font-bold mb-2" style={{fontFamily: 'Poppins', color: '#3A3F47', fontSize: '32px'}}>
            The Mindset Group
          </h1>
          <p style={{fontFamily: 'Source Sans Pro', color: '#6B6B6B', fontSize: '14px'}}>
            Login to access your dashboard
          </p>
        </div>

        {/* Login Form */}
        <div className="card-premium p-10 rounded">
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Label htmlFor="email" className="block mb-2 text-sm font-medium" style={{color: '#3A3F47'}}>
                Email Address
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@company.com"
                required
                className="w-full"
                style={{borderColor: '#E0DED9'}}
              />
            </div>

            <div>
              <Label htmlFor="password" className="block mb-2 text-sm font-medium" style={{color: '#3A3F47'}}>
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                className="w-full"
                style={{borderColor: '#E0DED9'}}
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full px-6 py-3 rounded text-xs font-semibold uppercase tracking-wider"
              style={{
                background: '#3A3F47',
                color: '#FFFFFF',
                fontFamily: 'Poppins, sans-serif'
              }}
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </Button>
          </form>

          {/* Demo Credentials */}
          <div className="mt-8 p-4 rounded" style={{background: '#F8F7F4'}}>
            <p className="text-xs font-semibold mb-2 uppercase tracking-wide" style={{color: '#D1A85B'}}>
              Demo Credentials
            </p>
            <div className="space-y-1" style={{fontSize: '13px', color: '#6B6B6B'}}>
              <p><strong>Email:</strong> demo@mindsetgroup.com</p>
              <p><strong>Password:</strong> demo123</p>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <p className="text-center mt-8 text-xs" style={{color: '#6B6B6B'}}>
          By logging in, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
